/* eslint-disable @atlaskit/ui-styling-standard/no-classname-prop */
import React from 'react';
/**
 * Generate a className based on the breakpoints provided.
 *
 * **Warning** - must much classnames defined in ResponsiveContainer.tsx
 * @param above - The breakpoint to show the element above.
 * @param below - The breakpoint to show the element below.
 * @returns The className to apply to the element.
 */
var generateClassName = function generateClassName(above, below) {
  if (above) {
    return "show-above-".concat(above);
  }
  if (below) {
    return "show-below-".concat(below);
  }
  return;
};

/**
 * Conditionally renders children based on responsive breakpoints.
 * Use either `above` or `below` prop to control visibility.
 *
 * *note:* This component must be an ancestor of a ResponsiveContainer component to work correctly
 * as it relies on CSS container queries.
 */
export var Show = function Show(_ref) {
  var children = _ref.children,
    above = _ref.above,
    below = _ref.below;
  return /*#__PURE__*/React.createElement("div", {
    className: generateClassName(above, below)
  }, children);
};